import * as React from "react";
const SvgSok = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	viewBox: "0 0 48.2 48.2",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fill: "currentColor",
	d: "m40.4 34.3-.9-.6-6.5-4.9c1.4-2.2 2.3-4.9 2.3-7.8 0-7.9-6.4-14.4-14.4-14.4S6.5 13.1 6.5 21s6.4 14.4 14.4 14.4c3 0 5.7-.9 8-2.4l4.8 6.2 1 1.3c.7.7 1.7 1.1 2.8 1.1 2.3 0 4.2-1.9 4.2-4.2 0-1.3-.5-2.3-1.3-3.1m-10.7-8c-.8 1.4-2 2.5-3.3 3.4-1.6 1-3.5 1.6-5.5 1.6-5.7 0-10.3-4.6-10.3-10.3s4.6-10.3 10.3-10.3S31.2 15.3 31.2 21c0 2-.6 3.8-1.5 5.3"
}));
export default SvgSok;
